import React from 'react';
import PropTypes from 'prop-types';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationEditViewTel extends React.Component {

  textFieldDidEndEditing(e) {
    this.props.delegate.changeTel(e.currentTarget.name, e.currentTarget.value);
  }

  render() {
    const reservation = this.props.reservation;
    const errors = this.props.errors;

    return (
      <td>
        <SMFormTextField
          name="reserved_user[tel]"
          value={reservation.user ? reservation.user.tel : ''}
          options={{className: 'w400'}} placeholderText="09012345678" delegate={this} />
        <span
          className="message-important ml10">{SMFormatHelper.errorText('Reservation', 'reservation_user.tel', errors)}</span>
      </td>

    );
  }
}

SMReservationEditViewTel.propTypes = {
  reservation: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewTel;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewTel.jsx